/** @format */

import moment, { Moment } from 'moment';
import { GeneralHelper } from './GeneralHelper';

export class DateHelperTs {
    static getCurrentTimeStamp(): number {
        return moment().unix();
    }

    static convertToMoment(date: string): Moment | null {
        try {
            return moment(date);
        } catch (e) {
            return null;
        }
    }

    static reformatDate(date: string, from = 'DD-MM-YYYY', to = 'YYYY-MM-DD'): string {
        return moment(date, from).format(to);
    }

    static addMonthsToDate(moment: Moment, addMonths: number): Moment {
        moment.add(addMonths, 'months');
        return moment;
    }

    static addDaysToDate(moment: Moment, addDays: number): Moment {
        moment.add(addDays, 'days');
        return moment;
    }

    static dateDiff(startDate: string | Date, endDate: string | Date, type: moment.unitOfTime.Base = 'hours'): number {
        return moment(endDate).diff(moment(startDate), type);
    }

    static getCurrentDateSimple(format = 'YYYY-MM-DD'): string {
        return moment().format(format);
    }

    static getMonthFirstDaySimple(moment: Moment, format = 'YYYY-MM-01'): string {
        return moment.startOf('month').format(format);
    }

    static getMonthLastDaySimple(moment: Moment, format = 'YYYY-MM-DD'): string {
        return moment.endOf('month').format(format);
    }

    static getCurentDate(): string {
        return moment().format('YYYY-MM-DD 23:59:59');
    }

    static getCurrentDateTime(): string {
        return moment().format('YYYY-MM-DD HH:mm:ss');
    }

    static setEndOfDayTime(date: string): string {
        const dateMoment = moment(date);
        dateMoment.hours(23);
        dateMoment.minutes(59);
        dateMoment.seconds(59);
        return dateMoment.format('YYYY-MM-DD HH:mm:ss');
    }

    static setStartOfMonth(date: string): string {
        const dateMoment = moment(date);
        dateMoment.hours(0);
        dateMoment.minutes(0);
        dateMoment.seconds(0);
        dateMoment.date(1);
        return dateMoment.format('YYYY-MM-DD HH:mm:ss');
    }

    static format(date: string, format = 'YYYY-MM-DD HH:mm:ss'): string {
        try {
            if (date) {
                return moment(date).format(format);
            }
        } catch (e) {
            console.log(e);
        }
        return '';
    }

    static getTime(date: Moment | string): string {
        try {
            if (typeof date === 'string') {
                return moment(date).format('HH:mm');
            } else {
                return date.format('HH:mm');
            }
        } catch (e) {
            console.error(e);
        }

        return '';
    }

    static parseTimeFromSec = (time: number): string => {
        let dateObj = new Date(time * 1000);
        let hours = dateObj.getUTCHours();
        let minutes = dateObj.getUTCMinutes();
        let seconds = dateObj.getSeconds();

        let timeString = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');

        return timeString;
    };

    static getMonths(asApiResponse = false, capitalize = false): object {
        if (asApiResponse) {
            const months = moment.months('MMMM');
            let i = 0;
            const x = {
                'hydra:member': months.map((el: string) => {
                    i++;
                    return { id: i, name: !capitalize ? el : GeneralHelper.capitalize(el) };
                }),
            };
            return x;
        } else {
            return moment.months();
        }
    }

    static getFirstDayOfMonthByMonthNumber(monthNumber: number): any {
        try {
            const actualDate = moment();
            const fixedDate = actualDate.month(monthNumber - 1).hours(15);
            return fixedDate.startOf('month');
        } catch (e) {
            console.log(e);
        }
    }

    static getLastDayOfMonthByMonthNumber(monthNumber: number): any {
        try {
            const actualDate = moment();
            const fixedDate = actualDate.month(monthNumber - 1);
            return fixedDate.endOf('month');
        } catch (e) {
            console.log(e);
        }
    }
}
